export default "__VITE_ASSET__DKyktvi___"